
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"250","height":"336","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M237.734 295.217l-225.468 39.8C5.5 336.219 0 331.679 0 324.904V54.428c0-6.775 5.483-13.25 12.266-14.435L237.734.193C244.5-1.01 250 3.53 250 10.306v270.492c-.017 6.759-5.5 13.234-12.266 14.419z","fill":"#000"}}),_c('path',{attrs:{"d":"M170.771 195.624c0 16.988-12.882 32.958-29.581 35.912l-61.98 10.947V104.174l62.18-10.98c16.699-2.954 29.381 8.527 29.381 25.499v76.931zm-14.882-72.459c0-12.883-8.249-17.355-20.932-15.119l-40.847 7.209v110.891l40.847-7.21c12.666-2.236 20.932-9.628 20.932-22.528v-73.243z","fill":"#fff"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","d":"M0 0h250v335.21H0z"}})])])])
          )
        }
      }
    